import Vuex from "vuex";

const state = {
  tips: '',
  btnArr: [],
  type: 'primary',
  packInfo: [],
  active: false,
  gameInfo: {},
}

const actions = {

}

const mutations = {
  setParams(state, param) {
    const {tips='', btnArr=[], type='primary', active=false, packInfo=[], gameInfo={}} = param;
    state.tips = tips;
    state.btnArr = btnArr;
    state.type = type;
    state.active = active;
    state.gameInfo = gameInfo;
    // packInfo业务处理
    const isVip = type == 'vip';
    if (packInfo.extraTime && !isVip){
      state.packInfo = [{
        name: `1张冰雪券`,
        img: require('../assets/winterOlympics/dialog/snow_ticket.png'),
      }, {
        name: `${packInfo.extraTime}小时时长`,
        img: require('../assets/winterOlympics/dialog/prize_'+packInfo.extraTime+'.png'),
        expireTime: packInfo.expireTime, // 有效期
      }]
    }else {
      state.packInfo = [{
        name: `1张冰雪券`,
        img:  require('../assets/winterOlympics/dialog/snow_ticket.png'),
      }];

    }
  },
  clearParams(state){
    state.tips = '';
    state.btnArr = [];
    state.type = 'primary';
    state.packInfo = [];
    state.gameInfo = {};
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/dialog.js